import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import type { TextControlBaseProps } from './TextControlBase';

type FontWeight = TextControlBaseProps['fontWeight'];
type FontStyle = TextControlBaseProps['fontStyle'];

interface MaskProps {
  mask: string;
  value: string;
  fieldColor: string;
  fontWeight: FontWeight;
  fontStyle: FontStyle;
}

export const ProgressiveMask = ({
  mask,
  value,
  fieldColor,
  fontWeight,
  fontStyle
}: MaskProps) => {
  if (!mask) {
    return null;
  }

  const chars = mask.split('');

  const renderChar = (_: string, i: number) => {
    const faded = i < value.length;
    const charToRender = faded ? value[i] : mask[i];

    return (
      <Span
        key={i}
        _faded={faded}
        _color={fieldColor}
        _fontStyle={fontStyle}
        _fontWeight={fontWeight}
      >
        {charToRender}
      </Span>
    );
  };

  return chars.map(renderChar);
};

const Span = styled.span<{
  _faded: boolean;
  _color: string;
  _fontWeight: FontWeight;
  _fontStyle: FontStyle;
}>`
  color: ${({ _faded, _color }) =>
    _faded ? 'rgba(0,0,0,0)' : getColorWithAlpha(_color, 0.3)};
  font-weight: ${({ _fontWeight }) => _fontWeight};
  font-style: ${({ _fontStyle }) => _fontStyle};
`;
